import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '33',
  height: '42',
  viewBox: '-1 -1 35 44'
}, [
  h('path', {
    fill: '#85A5CA',
    d: 'M18.2 4.5C20.8 1 24.6 1 24.6 1s.5 3.2-2.1 6.3c-2.8 3.4-6 2.8-6 2.8s-.7-2.5 1.7-5.6m-1.4 8c1.4 0 3.9-1.8 7.2-1.8 5.6 0 7.9 4 7.9 4s-4.3 2.2-4.3 7.5c0 6.1 5.4 8.2 5.4 8.2s-3.9 10.5-9 10.5c-2.3 0-4.2-1.6-6.7-1.6s-5 1.6-6.7 1.6C6 40.9.1 30.8.1 22.8c0-7.9 5-12.1 9.7-12.1 3.1 0 5.4 1.8 7 1.8'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language_objc.es6.js